import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './NoteWarnings.module.css';
import { alertActions, noteActions } from '_actions'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CommonButton } from '_components';

class PatientHomeAdmissionNoteWarnings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            transfer: 'select',
            prepopulate: 'select'
        };
    }

    handleDDLChange(event) {
        this.setState({ selectValue: event.target.value });
    }

    startNote() {
        this.props.startNote(this.props.epno, false)

    }

    render() {
        return (
            <div className={styles.option_table}>
                <div className={styles.option_wrapper}>
                    <div>
                        <span className={styles.warning_label}> Warning: {this.props.noteWarning}</span>
                    </div>

                    <div className={styles.divider} />
                    <CommonButton title={'Start Note'} onClick={() => this.startNote()} className={styles.startNoteButton} >
                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                    </CommonButton>

                </div>
                <div></div>
                <span></span>
            </div>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        startNote: bindActionCreators(noteActions.startNote, dispatch),
        clearStartNote: bindActionCreators(noteActions.startNote, dispatch),
        alertError: bindActionCreators(alertActions.error, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let epno = ownprops.id;
    let noteWarning = state.ui.admissions[epno].startNoteDisplayWarnings;

    return {
        epno,
        noteWarning
    };
}

const connectedPatientHomeAdmissionNoteWarnings = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionNoteWarnings);
export { connectedPatientHomeAdmissionNoteWarnings as PatientHomeAdmissionNoteWarnings };

